const getHostName = (): string => {
  const hostname = process.env.NEXT_PUBLIC_WEB_VIEW_HOST || '';
  // enable in production:
  return hostname;
  // return "m.localhost";
};

/**
 * Server-side detection of React Native WebView.
 * Checks userAgent and host to determine if running in RN WebView.
 */
export function detectReactNativeWebView(
  userAgent: string = '',
  host: string = ''
): boolean | null {
  const ua = userAgent.toLowerCase();

  // Check if host matches WebView host
  const webViewHost = getHostName();
  if (webViewHost && host.includes(webViewHost)) {
    return true;
  }

  const isReactNative =
    ua.includes('reactnative') || // iOS RN WebView
    ua.includes('; wv') || // Android WebView
    ua.includes(' crosswalk'); // old Android RN engine

  if (isReactNative) {
    return true;
  }
  return null;
}

/**
 * Client-side check for RN WebView messaging capability.
 * Verifies window.ReactNativeWebView.postMessage exists for messaging.
 */
export function hasRNWebViewMessaging(): boolean {
  if (typeof window === 'undefined') return false;
  return !!(
    (
      window as Window & {
        ReactNativeWebView?: { postMessage: (msg: string) => void };
      }
    ).ReactNativeWebView &&
    typeof (
      window as Window & {
        ReactNativeWebView?: { postMessage: (msg: string) => void };
      }
    ).ReactNativeWebView?.postMessage === 'function'
  );
}
